import { render } from "./OwnerList.vue?vue&type=template&id=353621c2&scoped=true"
import script from "./OwnerList.vue?vue&type=script&lang=js"
export * from "./OwnerList.vue?vue&type=script&lang=js"

import "./OwnerList.vue?vue&type=style&index=0&id=353621c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353621c2"]])

export default __exports__